import { useId } from "react";
import { useTranslation } from "react-i18next";

import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_SIZES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import ConfirmationModal from "@/components_v2/Modal/ConfirmationModal";
import { useEnrollmentAction } from "@/domains/certifications/hooks/useEnrollmentAction";
import { EnrollmentActionsProps } from "@/features/certifications/participant-detail/types";

const EnrollmentActions = ({
  certification,
  participant,
}: EnrollmentActionsProps) => {
  const { t } = useTranslation();
  const hintId = useId();
  const { action, isBlockedByBan, openConfirm, confirmModalProps } =
    useEnrollmentAction({ certification, participant });

  if (!action) {
    return null;
  }

  return (
    <div className="flex flex-col items-end gap-100">
      <BaseButton
        variant={BUTTON_VARIANTS.TERTIARY}
        size={BUTTON_SIZES.SMALL}
        disabled={isBlockedByBan}
        ariaDescribedBy={isBlockedByBan ? hintId : undefined}
        onClick={openConfirm}
      >
        {t(`certification.admin.participant.${action}.button`)}
      </BaseButton>

      {isBlockedByBan && (
        <span id={hintId} className="certification-muted body-xs-regular">
          {t("certification.admin.participant.reinstate.banned")}
        </span>
      )}

      <ConfirmationModal {...confirmModalProps} />
    </div>
  );
};

export default EnrollmentActions;
